module.exports = __webpack_public_path__ + "img/the-hurse.2a37063c.jpg";